import t from 'tcomb';

export default t.interface({
  challenge_completed_id: t.String
}, { strict: true, name: 'ChallengeCompleted' });

